import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

/** El keyframe `destello-aterrizaje` de index.css más un respiro para terminar de pintarlo. */
const DESTELLO_MS = 2200

const DESTELLO_CLASS = 'destello-aterrizaje'

/** Aterrizaje D4: limpia el parámetro para que recargar no lo repita. `listo` avisa que la lista ya está en el DOM,
 * y el id devuelto deja abrir antes la pestaña donde vive el elemento. */
export function useHighlightParam(param: string, listo: boolean): string | null {
  const [searchParams, setSearchParams] = useSearchParams()
  const target = searchParams.get(param)

  useEffect(() => {
    if (!target || !listo) return
    // `data-highlight-id` y no `id`: la misma fila se pinta dos veces (tabla y tarjeta móvil); se elige la visible.
    const candidatos = [...document.querySelectorAll<HTMLElement>(`[data-highlight-id="${param}-${target}"]`)]
    const node = candidatos.find((el) => el.offsetParent !== null) ?? candidatos[0]
    if (!node) return
    node.scrollIntoView({block: 'center', behavior: 'auto'})
    node.classList.add(DESTELLO_CLASS)
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        next.delete(param)
        return next
      },
      {replace: true}
    )
    const timer = window.setTimeout(() => node.classList.remove(DESTELLO_CLASS), DESTELLO_MS)
    return () => window.clearTimeout(timer)
  }, [target, listo, param, setSearchParams])

  return target
}
